import { Box, Grid } from '@mui/material';
import FormView from '../../../../components/views/formView';
import { useFraudTypeForm } from './hook';
import { FraudTypeData } from './data';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    FRAUD_TYPE,
    FRAUD_TYPE_DETAIL,
    FRAUD_TYPE_EDIT,
    FRAUD_TYPE_NEW,
} from '../../../../../routes/paths';
import { FraudTypeParamsHistorical } from '../historical';

export const FraudTypeForm = () => {
    const {
        fraudType,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikFraudTypeData,
        fraudTypeHistorical,
        showHistorical,
        setShowHistorical,
    } = useFraudTypeForm();

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <FormView
                title={
                    fraudType && fraudType.id
                        ? 'Editar tipología de fraude'
                        : 'Crear tipología de fraude'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={fraudType?.id || ''}
                        buttonCreate={{
                            show: Boolean(fraudType?.id),
                            route: FRAUD_TYPE_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: FRAUD_TYPE,
                        }}
                        buttonUpdate={{
                            show: true,
                            route: FRAUD_TYPE_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: FRAUD_TYPE_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(fraudType?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <FraudTypeParamsHistorical
                        historical={fraudTypeHistorical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <FraudTypeData
                data={fraudType}
                onChangeFormik={(formik) => setFormikFraudTypeData(formik)}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
